<ng-container [formGroup]="form">
  <div class="group">
    <rask-selector
      label="{{'KUNDORDER_DETAIL_HANDELSSORTIMENT' | translate}}"
      aid="inputHandelssortiment"
      formControlName="handelssortiment"
      [rule]="validation.handelssortiment"
      [required]="true"
      [reverseLookup]="false"
      [ngClass]="{'low': !showLabels}"
      class="col-lg-12"
      [search]="searchForHandelssortiment"
      [itemDisabled]="handelssortimentDisabled"
      [viewFormatter]="handelssortimenViewFormatter"
      [raskDisabledControl]="readonly">
    </rask-selector>
    @if (!newMode) {
      <div
        popoverClass="svea-popover"
        placement="bottom-left"
        [autoClose]="'outside'"
        [ngbPopover]="alternativaHandelssortiment"
        class="alternative-text">
        {{'KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT' | translate}}
        ({{handelssortiment.length}})
      </div>
    }
    @if (!newMode) {
      <div
        popoverClass="svea-popover"
        placement="bottom-left"
        [autoClose]="'outside'"
        [ngbPopover]="inmatningshandelssortimentPopover"
        class="inmatningshandelssortiment-text">
        Mäts in som: {{ gallandeInmatningshandelssortiment() }} @if (kundorderrad.matchesViol3Regelverk) {
        <rask-info>Matchning i regelverk finns</rask-info>
      }
    </div>
  }
</div>
</ng-container>

<ng-template #alternativaHandelssortiment>
  <rask-alternativa-handelssortiment
    [alternativtHandelssortiment]="handelssortiment"
    [search]="searchForHandelssortiment"
    (onChange)="alternativaHandelssortimentChanged($event)"
    [formatter]="handelssortimenViewFormatter"
    [kundorderradId]="kundorderradId"
    [kundorderrad]="kundorderrad"
    [readonly]="readonly">
  </rask-alternativa-handelssortiment>
</ng-template>
<ng-template #inmatningshandelssortimentPopover>
  <rask-kundorderrad-inmatningshandelssortiment
    [inmatningshandelssortiment]="inmatningshandelssortiment"
    [matchesViol3Regelverk]="kundorderrad.matchesViol3Regelverk"
    [mottagningsplatsnummer]="kundorderrad.mottagningsplats.mottagningsplatsnummer"
    [beraknatInmatningshandelssortiment]="beraknatInmatningshandelssortiment"
    (onChange)="inmatningshandelssortimentChanged($event)"
    [kundorderradId]="kundorderradId"
    [readonly]="readonly">
  </rask-kundorderrad-inmatningshandelssortiment>
</ng-template>
